import { useEffect, useState } from "react";
import { FaxPageWrapper, FaxNavTabs, ViewContainer } from "./FaxStyled";
import SendFaxView from "./components/SendFaxView";
import FaxLogView from "./components/FaxLogView";
import IntakeFaxView from "./components/IntakeFaxView";
import { fetchFaxLines } from "../../service/fax";

/**
 * Fax page: reached from the sidebar fax icon.
 *
 * Tabs:
 *   - "Send Fax": ad-hoc PDF upload + number form, with the sender's
 *     outbound history below.
 *   - "Fax Log": paged, searchable log of everything received on the
 *     firm's fax lines with inline PDF previews.
 *   - "Intake Fax": the intake team's own line, received and sent as
 *     separate logs. Shown only while an active fax line labelled
 *     "Intake" is registered.
 *
 * Inbound faxes are handled by the regular Mail Intake sorter — this
 * page is the fax-specific window (send + log), not a second queue.
 */
const Fax = () => {
  const [activeTab, setActiveTab] = useState("send");
  const [intakeLine, setIntakeLine] = useState("");

  useEffect(() => {
    let cancelled = false;
    fetchFaxLines()
      .then((response) => {
        const lines = response?.data?.results || [];
        const intake = lines.find(
          (line) => (line.label || "").trim().toLowerCase() === "intake"
        );
        if (!cancelled && intake) setIntakeLine(intake.number);
      })
      .catch(() => {
        // No lines, no Intake tab — Send and Log are unaffected.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const tabItems = [
    { key: "send", label: "Send Fax" },
    { key: "log", label: "Fax Log" },
    ...(intakeLine ? [{ key: "intake", label: "Intake Fax" }] : []),
  ];

  return (
    <FaxPageWrapper>
      <FaxNavTabs
        activeKey={activeTab}
        items={tabItems}
        onChange={setActiveTab}
      />
      <ViewContainer>
        {activeTab === "send" && <SendFaxView />}
        {activeTab === "log" && <FaxLogView />}
        {activeTab === "intake" && intakeLine && (
          <IntakeFaxView line={intakeLine} />
        )}
      </ViewContainer>
    </FaxPageWrapper>
  );
};

export default Fax;
